import { IconBase, DynamicIcon, type IconName } from '@doxyme/icons';

import type { JSX } from 'react';

type VariantArgs = {
  color: string;
  borderColor: string;
  hasBorder?: boolean;
  className?: string;
  iconName?: IconName;
};

export const _3XL = ({
  color,
  borderColor,
  hasBorder = false,
  className,
  iconName,
}: VariantArgs): JSX.Element => (
  <IconBase
    size={40}
    viewBox='0 0 40 40'
    css={{ flexShrink: 0, zIndex: 1 }}
    className={className}
  >
    <path
      d='M20 2C10.0589 2 2 10.0589 2 20C2 29.9411 10.0589 38 20 38C29.9411 38 38 29.9411 38 20C38 10.0589 29.9411 2 20 2Z'
      stroke={borderColor}
      strokeWidth={hasBorder ? 4 : 0}
    />
    <circle cx='20' cy='20' r='16' fill={color} />
    {iconName && (
      <DynamicIcon name={iconName} size='small' x='10' y='10' color='white' />
    )}
  </IconBase>
);

export const _2XL = ({
  color,
  borderColor,
  hasBorder = false,
  className,
  iconName,
}: VariantArgs): JSX.Element => (
  <IconBase
    size={32}
    viewBox='0 0 32 32'
    css={{ flexShrink: 0, zIndex: 1 }}
    className={className}
  >
    <path
      d='M16 2C8.26801 2 2 8.26801 2 16C2 23.732 8.26801 30 16 30C23.732 30 30 23.732 30 16C30 8.26801 23.732 2 16 2Z'
      stroke={borderColor}
      strokeWidth={hasBorder ? 4 : 0}
    />
    <circle cx='16' cy='16' r='12' fill={color} />
    {iconName && (
      <DynamicIcon name={iconName} size='xsmall' x='8' y='8' color='white' />
    )}
  </IconBase>
);

export const Xl = ({
  color,
  borderColor,
  hasBorder = false,
  className,
  iconName,
}: VariantArgs): JSX.Element => (
  <IconBase
    size={28}
    viewBox='0 0 28 28'
    css={{ flexShrink: 0, zIndex: 1 }}
    className={className}
  >
    <path
      d='M14 2C7.37258 2 2 7.37258 2 14C2 20.6274 7.37258 26 14 26C20.6274 26 26 20.6274 26 14C26 7.37258 20.6274 2 14 2Z'
      stroke={borderColor}
      strokeWidth={hasBorder ? 4 : 0}
    />
    <circle cx='14' cy='14' r='10' fill={color} />
    {iconName && (
      <DynamicIcon name={iconName} size='xsmall' x='6' y='6' color='white' />
    )}
  </IconBase>
);

export const Lg = ({
  color,
  borderColor,
  hasBorder = false,
  className,
  iconName,
}: VariantArgs): JSX.Element => (
  <IconBase
    size={20}
    viewBox='0 0 20 20'
    css={{ flexShrink: 0, zIndex: 1 }}
    className={className}
  >
    <rect
      x='1'
      y='1'
      width='18'
      height='18'
      rx='9'
      stroke={borderColor}
      strokeWidth={hasBorder ? 2 : 0}
    />
    <circle cx='10' cy='10' r='8' fill={color} />
    {iconName && (
      <DynamicIcon
        name={iconName}
        width={12}
        height={12}
        x={4}
        y={4}
        color='white'
      />
    )}
  </IconBase>
);

export const Md = ({
  color,
  borderColor,
  hasBorder = false,
  className,
}: VariantArgs): JSX.Element => (
  <IconBase
    size={16}
    viewBox='0 0 16 16'
    css={{ flexShrink: 0, zIndex: 1 }}
    className={className}
  >
    <path
      d='M8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1Z'
      stroke={borderColor}
      strokeWidth={hasBorder ? 2 : 0}
    />
    <circle cx='8' cy='8' r='6' fill={color} />
  </IconBase>
);

export const Sm = ({
  color,
  borderColor,
  hasBorder = false,
  className,
}: VariantArgs): JSX.Element => (
  <IconBase
    size={12}
    viewBox='0 0 12 12'
    css={{ flexShrink: 0, zIndex: 1 }}
    className={className}
  >
    <rect
      x='1'
      y='1'
      width='10'
      height='10'
      rx='5'
      stroke={borderColor}
      strokeWidth={hasBorder ? 2 : 0}
    />
    <circle cx='6' cy='6' r='4' fill={color} />
  </IconBase>
);
